var render = function () {
  var _vm$contract$details, _vm$contract$details2, _vm$contract$details3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "pt-1",
    attrs: {
      "color": _vm.isSelected ? 'grey' : 'grey lighten-4',
      "dark": _vm.isSelected,
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "px-4"
  }, [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "dark": false,
      "color": _vm.isSelected ? 'white' : 'grey darken-3',
      "hide-details": "",
      "disabled": _vm.disabled || !_vm.hasCompany
    },
    model: {
      value: _vm.isSelected,
      callback: function callback($$v) {
        _vm.isSelected = $$v;
      },
      expression: "isSelected"
    }
  })], 1), _c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.companyName) + " ")]), _c('v-list-item-subtitle', {
    staticClass: "text-xs text-truncate mb-4"
  }, [_vm._v(" " + _vm._s(_vm.contractTypeLabel) + " ")]), _vm.report && _vm.clearance ? _c('v-list-item-subtitle', {
    staticClass: "text-xs"
  }, [_c('v-chip', {
    attrs: {
      "color": _vm.approvalLimitChecker.isRequired ? 'red' : '',
      "small": "",
      "dark": _vm.approvalLimitChecker.isRequired
    }
  }, [_vm.approvalLimitChecker.isRequired ? _c('span', [_vm._v(_vm._s(_vm.$t("clearance.isRequired")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("clearance.isOptional")))]), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('span', _vm._g({}, on), [_c('v-icon', {
          attrs: {
            "dark": _vm.approvalLimitChecker.isRequired,
            "small": "",
            "right": ""
          }
        }, [_vm._v(" mdi-information-slab-circle-outline ")])], 1)];
      }
    }], null, false, 1733202107)
  }, [_c('v-sheet', {
    staticClass: "no-print",
    attrs: {
      "dark": "",
      "color": "transparent",
      "max-width": "300"
    }
  }, [_vm._v(" " + _vm._s(_vm.approvalLimitChecker.explanation())), _c('br'), _c('br'), 'details' in _vm.contract ? [_vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.purchaseVehicleRepairApprovalLimit")) + ": " + _vm._s(_vm.formatCurrency((_vm$contract$details = _vm.contract.details) === null || _vm$contract$details === void 0 ? void 0 : _vm$contract$details.purchaseVehicleRepairApprovalLimit, _vm.CurrencyEnum.EUR))), _c('br'), _vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.comprehensiveRepairApprovalLimit")) + ": " + _vm._s(_vm.formatCurrency((_vm$contract$details2 = _vm.contract.details) === null || _vm$contract$details2 === void 0 ? void 0 : _vm$contract$details2.comprehensiveRepairApprovalLimit, _vm.CurrencyEnum.EUR))), _c('br'), _vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.liabilityRepairApprovalLimit")) + ": " + _vm._s(_vm.formatCurrency((_vm$contract$details3 = _vm.contract.details) === null || _vm$contract$details3 === void 0 ? void 0 : _vm$contract$details3.liabilityRepairApprovalLimit, _vm.CurrencyEnum.EUR)) + " ")] : _vm.contract.contractType === _vm.VehicleContractTypeEnum.INSURANCE ? [_vm._v(" " + _vm._s(_vm.$t("objects.contract.insurance.fullComprehensiveAppraiserLimit")) + ": " + _vm._s(_vm.formatCurrency(_vm.contract.fullComprehensiveAppraiserLimit, _vm.contract.currency))), _c('br'), _vm._v(" " + _vm._s(_vm.$t("objects.contract.insurance.partialCoverageAppraiserLimit")) + ": " + _vm._s(_vm.formatCurrency(_vm.contract.partialCoverageAppraiserLimit, _vm.contract.currency)) + " ")] : _vm.contract.contractType === _vm.VehicleContractTypeEnum.LEASING ? [_vm._v(" " + _vm._s(_vm.$t("objects.contract.leasing.approvalLimit")) + ": " + _vm._s(_vm.formatCurrency(_vm.contract.approvalLimit, _vm.contract.currency)) + " ")] : _vm._e()], 2)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }